import React, { useEffect, useState } from "react";
import SideBar from "../../../SideBar/SideBar";
import Header from "../../../Header/Header";
import { Link } from "react-router-dom";
import "../anttab.css";
import './chatsupport.css'
import { CommentOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";
import ChatComponent from "../../../ChatComponent";
import Uploaddoc from "../Chatsupport/Uploaddoc";
import { useLocation } from 'react-router-dom';



const TabContent = ({ activeTab, applicationId }) => {

  const documentFiles = [];

  const documentUploadMethod = (event, type) => {
    const fileInput = event.target;
    const file = fileInput.files[0];

    const existingDocumentIndex = documentFiles.findIndex(doc => doc.type === type);

    if (existingDocumentIndex !== -1) {
      documentFiles[existingDocumentIndex] = {
        file: file,
        type: type
      };
    } else {
      let fileObj = {
        file: file,
        type: type
      };
      documentFiles.push(fileObj);
    }

    console.log("files added-->", documentFiles);
  };

  const submitFinalDoccuments = () => {
    if (documentFiles.length > 0) {
      documentFiles.map(async (file) => {
        // const response = await uploadApplicationDocuments(applicationId, file.type, file.file);
        console.log("file upload res-->", file);
      })
    } else {
      console.log("No document is selected")
    }
  }
  const handleFileUpload = (name) => {
    const fileInput = document.getElementById(name);
    if (fileInput) {
      fileInput.click();
    } else {
      console.error(`Element with id ${name} not found`);
    }
  };

  const handleUpload = (file) => {
    // Use FileReader to read the file and extract information
    const reader = new FileReader();

    reader.onloadend = () => {
      const uploadInfo = {
        name: file.name,
        type: 'Recommendation', // You can customize the type
        content: reader.result, // If you need to use the file content
      };

      // Add the new upload to the array
      setUploads([...uploads, uploadInfo]);
    };

    // Start reading the file
    reader.readAsDataURL(file);
  };
  const [uploads, setUploads] = useState([])
  const handleFileInputChange = (event) => {
    const files = event.target.files;

    // Handle multiple files if needed
    for (let i = 0; i < files.length; i++) {
      handleUpload(files[i]);
    }
  };

  return (
    <div>
      <div className="tab-content tab-chatcomopnet chattab-content" >
        {activeTab === 'active' && <div>
          <>
            <ChatComponent applicationId={applicationId} />

          </></div>}
        {activeTab === 'link1' && <div><div>


          {/* <Uploaddoc /> */}

          <div className="mt-1">
            <div className="uplaoddocnormal mt-3 ">
              <div className="uploadcardiamges">
                <img src="https://w7.pngwing.com/pngs/404/627/png-transparent-microsoft-excel-excel-services-spreadsheet-microsoft-office-specialist-microsoft-angle-text-rectangle.png" alt="xlimages" className="normalxlimage" />
              </div>
              <div className="uploadtext" onClick={() => handleFileUpload('fileInputSop')}>
                <strong>Add Statement Of PurPose - SOP</strong></div>
              <div className="uploadbuttongroup">
                <strong>admin</strong>
                <i class="fa-solid fa-download"></i>
                <i class="fa-solid fa-ellipsis"></i>
                {/* <button className="btn btn-primary btnbuttondoc">Sop</button> */}
              </div>
              <input
                type="file"
                id="fileInputSop"
                style={{ display: 'none' }}
                onChange={(event) => documentUploadMethod(event, 'sop')}
              />

            </div>

            <div className="uplaoddocnormal mt-3 ">
              <div className="uploadcardiamges">
                <img src="https://w7.pngwing.com/pngs/404/627/png-transparent-microsoft-excel-excel-services-spreadsheet-microsoft-office-specialist-microsoft-angle-text-rectangle.png" alt="xlimages" className="normalxlimage" />
              </div>
              <div className="uploadtext" onClick={() => handleFileUpload('fileInputLor1')}><strong >Add Letter Of Recommendation - LOR01</strong></div>
              <div className="uploadbuttongroup">

                <strong>admin</strong>
                <i class="fa-solid fa-download"></i>
                <i class="fa-solid fa-ellipsis"></i>
                {/* <button className="btn btn-primary btnbuttondoc">Sop</button> */}
              </div>
              <input
                type="file"
                id="fileInputLor1"
                style={{ display: 'none' }}
                onChange={(event) => documentUploadMethod(event, 'lor1')}
              />
            </div>

            <div className="uplaoddocnormal mt-3 ">
              <div className="uploadcardiamges">
                <img src="https://w7.pngwing.com/pngs/404/627/png-transparent-microsoft-excel-excel-services-spreadsheet-microsoft-office-specialist-microsoft-angle-text-rectangle.png" alt="xlimages" className="normalxlimage" />
              </div>
              <div className="uploadtext" onClick={() => handleFileUpload('fileInputLor2')}><strong >Add Letter Of Recommendation - LOR02</strong></div>
              <div className="uploadbuttongroup">
                <strong>Student</strong>
                <i class="fa-solid fa-download"></i>
                <i class="fa-solid fa-ellipsis"></i>
                {/* <button className="btn btn-primary btnbuttondoc">Sop</button> */}
              </div>
              <input
                type="file"
                id="fileInputLor2"
                style={{ display: 'none' }}
                onChange={(event) => documentUploadMethod(event, 'lor2')}
              />

            </div>
            <div className="uplaoddocnormal mt-3 ">
              <div className="uploadcardiamges">
                <img src="https://w7.pngwing.com/pngs/404/627/png-transparent-microsoft-excel-excel-services-spreadsheet-microsoft-office-specialist-microsoft-angle-text-rectangle.png" alt="xlimages" className="normalxlimage" />
              </div>
              <div className="uploadtext" onClick={() => handleFileUpload('fileInputLor3')}><strong >Add Letter Of Recommendation - LOR03</strong></div>
              <div className="uploadbuttongroup">
                <strong>Student</strong>
                <i class="fa-solid fa-download"></i>
                <i class="fa-solid fa-ellipsis"></i>
                {/* <button className="btn btn-primary btnbuttondoc">Sop</button> */}
              </div>
              <input
                type="file"
                id="fileInputLor3"
                style={{ display: 'none' }}
                onChange={(event) => documentUploadMethod(event, 'lor3')}
              />

            </div>

            {uploads.map((upload, index) => (
              <div key={index} className="uplaoddocnormal mt-3">
                <div className="uploadcardiamges">
                  <i className="fa-solid fa-file fs-3"></i>
                </div>
                <div className="uploadtext">
                  <strong>{`Add ${upload.type} - ${upload.name}`}</strong>
                </div>
                <div>
                  <i className="fa-solid fa-upload" style={{ marginRight: '0.3rem' }}></i>
                </div>
              </div>
            ))}
          </div>

        </div>
        </div>}


        {activeTab === 'link2' && <div>Content for Recent Chats tab</div>}
      </div>


      {activeTab === 'link1' && <div className="message-box w-100" style={{ marginTop: "-0.6rem", marginLeft: '0.3rem', }}>
        <label className="imagedocument   ">

          {/* mt-2 */}
          <input
            type="file"
            onChange={handleFileInputChange}
            multiple
            style={{ display: 'none', gap: '10px' }} // Hide the input element
          />
          <div className="iconscenter">
            <i class="fa-solid fa-face-smile fs-5 " style={{ marginRight: '10px', }} ></i>

            <i class="fa-regular fa-image fs-5" style={{ marginRight: '10px', }} onChange={handleFileInputChange}></i>
            <i class="fa-solid fa-file-shield  fs-5"></i>
          </div>
        </label>
        <button type="button" className="message-submit" onClick={submitFinalDoccuments} >
          <i class="fa-solid fa-paper-plane"></i> Send
        </button>
      </div>}
    </div>

  );
};

const ChatSupport = () => {
  const [chat, setChange] = useState("11");
  const [showchat, setshowchat] = useState(true)
  const [doc, setdoc] = useState(false);
  const location = useLocation();
  const { state } = location;
  const [applicationDetails, setApplicationDetails] = useState(null);

  const applicationId = applicationDetails ? applicationDetails.applicationId : null;
  console.log("applicationId", applicationId);

  const passIdToChat = () => {

  }



  const handlechage = (event) => {
    const { value, name } = event.target;
    setChange({
      ...chat,
      [name]: value,
    });
    console.log(chat);
  };

  useEffect(() => {

    if (state && state.applicationDetails) {
      setApplicationDetails(state.applicationDetails);
    }
    console.log("applicationDetails-->", applicationDetails);
  }, [chat, doc, state]);

  const [activeTab, setActiveTab] = useState('active');

  const handleTabClick = (tab, event) => {
    event.preventDefault();
    setActiveTab(tab);
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />
        {/* Sidebar */}
        <SideBar />
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">University ChatCard</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Profile</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-12">
                <div className="mt-3">
                  <div class="card " style={{ backgroundColor: "white" }}>
                    <div class="card-body">
                      <div class="card univercitychatbacground" style={{ backgroundColor: "#F5F5F7" }}>
                        <div class="card-body gridchatsuppot">
                          {/* univercitychatcomponet */}
                          <div className="chatcontainer">

                            <div class="card univercitychat" >
                              <img src="https://images.pexels.com/photos/256490/pexels-photo-256490.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" class="card-img-to" alt="..." />
                              {applicationDetails ? (

                                <div class="card-body">
                                  {/* <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}

                                  <div className="apliactionid">
                                    Application Id: {applicationDetails.applicationId}
                                  </div>
                                  <div className="cardunivercityname">
                                    <p><i class="fa-solid fa-school fw-bold"></i> <strong>{applicationDetails.name}</strong></p>
                                    <p><i class="fa-solid fa-graduation-cap fw-bold"></i>{applicationDetails.university}</p>
                                    <p><i class="fa-solid fa-calendar-days fw-bold"></i> <strong>{applicationDetails.year}  </strong></p>
                                    <p><i class="fa-solid fa-floppy-disk fw-bold"></i> <strong>{applicationDetails.intakes}</strong></p>
                                    <p>
                                      <i className="fa-regular fa-circle-check"></i>
                                      <strong>Status :</strong>
                                      <strong className={`${applicationDetails.status === "apply" || "payment-successful" ? "chatsupprotsuccess" : "chatsupproterrr"}`}>
                                        {applicationDetails.status}
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <p>No application details provided</p>
                              )}

                            </div>


                          </div>
                          {/* chatwith univercity */}
                          <div className="chatcontainer1">
                            <ul className="nav nav-tabs">
                              <li className={`navborderraious nav-item1 nav-item ${activeTab === 'active' ? 'active navborderraious' : ''}`}>
                                <a
                                  // className="nav-link"  
                                  className={`nav-link ${activeTab === 'active' ? 'nav-likechat' : ''}`}
                                  style={{ color: 'black', fontSize: '16px' }}
                                  onClick={(e) => handleTabClick('active', e)}
                                  href="#"
                                >
                                  Chats
                                </a>
                              </li>
                              <li className={` nav-item1 nav-item ${activeTab === 'link1' ? 'active navborderraious' : ''}`}>
                                <a
                                  className={`nav-link ${activeTab === 'link1' ? 'nav-likechatdoc' : ''}`} style={{ color: 'black', fontSize: '16px' }}
                                  onClick={(e) => handleTabClick('link1', e)}
                                  href="#"
                                >
                                  Documents
                                </a>
                              </li>
                              {/* <li className={` nav-item1 nav-item ${activeTab === 'link2' ? 'active' : ''}`}>
          <a
            className="nav-link"
            onClick={(e) => handleTabClick('link2', e)}
            href="#"
          >
            Recent Chats
          </a>
        </li> */}
                            </ul>

                            <TabContent activeTab={activeTab} applicationId={applicationId} />




                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* /Main Wrapper */}
    </>
  );
};

export default ChatSupport;
